import React, { useContext, useEffect, useRef, useState } from "react";
import { UserData } from "../contexts/UserInfoContext";
import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import ScrollTop from "../components/shared/ScrollTop";
import { Toast } from "primereact/toast";
import { getItemStorage } from "../Localstorage/useLocalStorage";
import { Link, useLocation, useParams } from "react-router-dom";
import { getData, postData } from "../services/API";
import { getWindowSize, toFarsiNumber } from "../helper/helper";
import master from "../images/master.png";
import pic from "../images/pic.jpg";
import { Dropdown } from "primereact/dropdown";
import Footer from "../components/Footer/Footer";
import Skeleton from "react-loading-skeleton";
import AcademyEpisodeLoading from "../components/Academy/AcademyEpisodeLoading";
import Loading from "../components/shared/Loading";
import avatar from "../images/avatar.png";
import { Rating } from "primereact/rating";
import SendComment from "../components/Academy/SendComment";
import AcademyComment from "../components/Academy/AcademyComment";
import NewAcademyCard from "../components/Academy/NewAcademyCard";
import EpisodeItem from "../components/Academy/EpisodeItem";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import CircleLoading from "../components/shared/CircleLoading";

export default function NewAcademyPage() {
  const { user } = useContext(UserData);
  const [course, setCourse] = useState({});
  const [loading, setLoading] = useState(true);
  const [commentLoading, setCommentLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [rate, setRate] = useState(null);
  const [rateSended, setRateSended] = useState(false);
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState({});
  const [percent, setPercent] = useState("0");
  const [sendRate, setSendRate] = useState(false);
  const [rateLoading, setRateLoading] = useState(false);
  const [isRateSubmitted, setIsRateSubmitted] = useState(null);
  const [licLoading, setLicLoading] = useState(false);
  const [lic, setLic] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [bgImage, setBgImage] = useState("");
  const [qa, setQa] = useState([]);
  const [qaLoading, setQaLoading] = useState(true);
  const [openDesc, setOpenDesc] = useState(false);
  const [more, setMore] = useState([]);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [showList, setShowList] = useState(false);

  const token = getItemStorage("token");
  const param = useParams("slug");

  const toastErr = useRef(null);
  const toastSucc = useRef(null);
  const scroll = useRef(null);

  const loc = useLocation();

  useEffect(() => {
    setLoading(true);
    setBgImage("");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleWindowResize);

    getData(`/acd/lesson/show/${param.slug}`, {}, true)
      .then((res) => {
        setCourse(res.data.lesson);
        setMore(res.data.more);
        setPercent(res.data.percent);
        setUnits(res.data.lesson.units);
        setBgImage(res.data.lesson.poster);
        setPercent(res.data.percent);
        setLic(res.data.requested_license);

        if (res.data.lesson.units.length > 0) {
          setSelectedUnit(res.data.lesson.units[0]);
        }

        // check if rate submitted
        if (res.data.rate?.number) {
          setIsRateSubmitted(res.data.rate?.number);
          setRate(res.data.rate?.number);
        }

        setLoading(false);

        // get qa
        postData(
          `/acd/comment/get-lesson-qa`,
          { lesson_id: res.data.lesson.id, page: 1 },
          true
        )
          .then((res) => {
            setQa(res.data.comments);
            setQaLoading(false);
          })
          .catch((res) => {
            toastErr.current.show({
              severity: "error",
              summary: "خطا هنگام دریافت پرسش و پاسخ",
              detail: "لطفا دوباره صفحه را بارگذاری کنید",
              life: 3500,
            });
          });

        // get comments
        postData(
          `/acd/comment/get-lesson-comments`,
          { lesson_id: res.data.lesson.id, page: 1 },
          true
        )
          .then((res) => {
            setComments(res.data.comments);
            setCommentLoading(false);
          })
          .catch((res) => {
            toastErr.current.show({
              severity: "error",
              summary: "خطا هنگام دریافت دیدگاه کاربران",
              detail: "لطفا دوباره صفحه را بارگذاری کنید",
              life: 3500,
            });
          });
      })
      .catch((res) => {
        toastErr.current.show({
          severity: "error",
          summary: "خطا هنگام دریافت اطلاعات از سرور",
          detail: "لطفا دوباره صفحه را بارگذاری کنید",
          life: 3500,
        });
      });
  }, [loc]);

  const rateOnChangeHandler = (e) => {
    setRate(e.value);
    setSendRate(true);
  };

  const rateSendHandler = () => {
    setRateLoading(true);

    if (!rateSended) {
      postData("/acd/lesson/rate", { number: rate, lesson_id: course.id })
        .then((res) => {
          setSendRate(false);
          setRateSended(true);
          toastSucc.current.show({
            severity: "success",
            summary: "با موفقیت انجام شد",
            detail: "امتیاز شما با موفقیت ثبت شد",
            life: 3500,
          });
        })
        .catch((err) => {
          toastErr.current.show({
            severity: "error",
            summary: "خطا هنگام ثبت امتیاز",
            detail: "شما به این دوره قبلا امتیاز داده اید.",
            life: 3500,
          });
        });
    }
  };

  let productPerView2;
  if (windowSize.innerWidth < 720) {
    productPerView2 = 2;
  } else if (windowSize.innerWidth < 885) {
    productPerView2 = 3;
  } else if (windowSize.innerWidth >= 640 && windowSize.innerWidth <= 1230) {
    productPerView2 = 4;
  } else {
    productPerView2 = 5;
  }
  // /acd/comment/get-lesson-qa

  const licRequestHandler = () => {
    setLicLoading(true);
    postData("/acd/lesson/request-license", { lesson_id: course.id })
      .then((res) => {
        toastSucc.current.show({
          severity: "success",
          summary: "درخواست شما با موفقیت ثبت شد",
          detail:
            "گواهی شما بعد از تایید مدیریت به پنل کاربری شما اضافه خواهد شد",
          life: 3500,
        });
        setLicLoading(false);

        setLic(true);
      })
      .catch((err) => {
        toastSucc.current.show({
          severity: "error",
          summary: "خطا هنگام ثبت درخواست",
          detail: err.response.data.message,
          life: 3500,
        });

        setLicLoading(false);
      });
  };

  return (
    <div className="flex flex-col items-center">
      <Header className={"!bg-transparent absolute z-50"} />
      <MobileNavbar />
      <MobileHeader />
      <ScrollTop />
      <Toast ref={toastSucc} />
      <Toast ref={toastErr} />

      {/* header of page & info */}
      <div
        style={{
          backgroundImage: `linear-gradient(
        rgba(21, 21, 21, 0) 10vw,
        rgb(21, 21, 21) 46.875vw
      ),
      linear-gradient(to left, rgba(21, 21, 21, 0.7), rgba(21, 21, 21, 0) 50%),url(https://api.myunibest.com/${bgImage})`,
        }}
        className="w-full lg:h-[895px] pt-32 flex justify-center academy-bg items-center"
      >
        {loading ? (
          <div className="w-full max-w-[1300px] flex flex-col gap-4 px-3 2xl:px-0">
            <Skeleton className="hidden w-full lg:block max-w-64 h-36 rounded-xl -mt-4" />
            <Skeleton className="block w-full max-w-96 h-8 rounded-xl -mt-4" />
            <Skeleton className="block w-full max-w-96 h-8 rounded-xl -mt-4" />
            <Skeleton className="block w-full max-w-[650px] h-5 rounded-xl -mt-4" />
            <Skeleton className="block w-full max-w-[650px] h-5 rounded-xl -mt-6" />
            <Skeleton className="block w-full max-w-80 h-5 rounded-xl -mt-6" />
            <Skeleton className="block w-40 h-12 rounded-xl -mt-4" />
          </div>
        ) : (
          <div className="w-full max-w-[1300px] text-gray-200 flex flex-col gap-5 px-3 2xl:px-0">
            {/* <img src={master} className="w-60 hidden md:block" alt="" /> */}
            <h1 className="lg:text-3xl text-2xl font-black">{course.name}</h1>
            <h2 className="lg:text-xl text text-gray-300 -mt-4 font-semibold">
              {course.name_en}
            </h2>

            <div className="flex flex-wrap items-center gap-8">
              {/* year */}
              {course.year && (
                <div className="flex items-center text-sm gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="w-5 h-5 fill-gray-200"
                  >
                    <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
                    <path
                      fill-rule="evenodd"
                      d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span>{toFarsiNumber(String(course.year))}</span>
                </div>
              )}

              {course.creator && (
                <div className="flex items-center text-gray-200 text-sm gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-5"
                  >
                    <path d="M4.5 4.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3H4.5ZM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06Z" />
                  </svg>

                  <span>{course.creator.name}</span>
                </div>
              )}

              {/* duration */}
              {course.duration && (
                <div className="flex items-center text-sm gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="w-5 h-5 fill-gray-200"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span>{toFarsiNumber(course.duration)}</span>
                </div>
              )}

              {/* special */}
              {course.special === 1 && (
                <div className="flex items-center text-sm gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="w-5 h-5 fill-red-600"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span className="text-red-600">اختصاصی</span>
                </div>
              )}

              {/* subtitle */}
              {course.has_sub === 1 && (
                <div className="flex items-center text-sm gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    class="fill-gray-200 w-5 h-5"
                  >
                    <path
                      class="svg-c1"
                      d="M14.216 3H6.26a3.26 3.26 0 0 0-3.26 3.26v7.957a3.26 3.26 0 0 0 3.26 3.26h7.955a3.26 3.26 0 0 0 3.26-3.26V6.262A3.26 3.26 0 0 0 14.216 3zM6.2 14.428a.9.9 0 0 1 0-1.8.9.9 0 0 1 .636 1.537.9.9 0 0 1-.637.263zm8.077 0h-5.31a.9.9 0 1 1 0-1.8h5.3a.9.9 0 1 1 0 1.8zm0-3.356H6.2a.9.9 0 0 1 0-1.8h8.076a.9.9 0 0 1 0 1.8zm0-3.222H6.2a.9.9 0 1 1 0-1.8h8.076a.9.9 0 1 1 0 1.8z"
                    ></path>
                  </svg>

                  <span>زیرنویس فارسی</span>
                </div>
              )}

              {/* dubbled */}
              {course.has_saudio === 1 ? (
                <div className="flex items-center text-sm gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="w-5 h-5 fill-yellow-700"
                  >
                    <path d="M8.25 4.5a3.75 3.75 0 1 1 7.5 0v8.25a3.75 3.75 0 1 1-7.5 0V4.5Z" />
                    <path d="M6 10.5a.75.75 0 0 1 .75.75v1.5a5.25 5.25 0 1 0 10.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5a6.751 6.751 0 0 1-6 6.709v2.291h3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3v-2.291a6.751 6.751 0 0 1-6-6.709v-1.5A.75.75 0 0 1 6 10.5Z" />
                  </svg>

                  <span className="text-yellow-700">دوبله اختصاصی</span>
                </div>
              ) : (
                course.has_audio === 1 && (
                  <div className="flex items-center text-sm gap-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="w-5 h-5 fill-gray-200"
                    >
                      <path d="M8.25 4.5a3.75 3.75 0 1 1 7.5 0v8.25a3.75 3.75 0 1 1-7.5 0V4.5Z" />
                      <path d="M6 10.5a.75.75 0 0 1 .75.75v1.5a5.25 5.25 0 1 0 10.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5a6.751 6.751 0 0 1-6 6.709v2.291h3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3v-2.291a6.751 6.751 0 0 1-6-6.709v-1.5A.75.75 0 0 1 6 10.5Z" />
                    </svg>

                    <span>دوبله فارسی</span>
                  </div>
                )
              )}

              {/* multi lang */}
              {course.multi_lang === 1 && (
                <div className="flex items-center text-sm gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="w-5 h-5 fill-gray-200"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M9 2.25a.75.75 0 0 1 .75.75v1.506a49.384 49.384 0 0 1 5.343.371.75.75 0 1 1-.186 1.489c-.66-.083-1.323-.151-1.99-.206a18.67 18.67 0 0 1-2.97 6.323c.318.384.65.753 1 1.107a.75.75 0 0 1-1.07 1.052A18.902 18.902 0 0 1 9 13.687a18.823 18.823 0 0 1-5.656 4.482.75.75 0 0 1-.688-1.333 17.323 17.323 0 0 0 5.396-4.353A18.72 18.72 0 0 1 5.89 8.598a.75.75 0 0 1 1.388-.568A17.21 17.21 0 0 0 9 11.224a17.168 17.168 0 0 0 2.391-5.165 48.04 48.04 0 0 0-8.298.307.75.75 0 0 1-.186-1.489 49.159 49.159 0 0 1 5.343-.371V3A.75.75 0 0 1 9 2.25ZM15.75 9a.75.75 0 0 1 .68.433l5.25 11.25a.75.75 0 1 1-1.36.634l-1.198-2.567h-6.744l-1.198 2.567a.75.75 0 0 1-1.36-.634l5.25-11.25A.75.75 0 0 1 15.75 9Zm-2.672 8.25h5.344l-2.672-5.726-2.672 5.726Z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span>چند زبانه</span>
                </div>
              )}
            </div>

            <p className="w-full text-sm max-w-[600px] leading-7">
              {course.short_desc}
            </p>
            {/* {console.log(
              course.buy === false ||
                (user?.user?.developer === 1 && course.for_rank === 1)
            )} */}
            {course.buy === false ||
            user?.user?.developer === 1 ||
            course?.ranks?.filter(
              (item) => item.rank >= user?.user?.level || item.rank === 100
            ).length ? (
              <button
                onClick={() => {
                  scroll.current?.scrollIntoView({ behavior: "smooth" });
                }}
                className="w-fit px-4 h-11 flex justify-center items-center gap-1 bg-gray-200 hover:bg-transparent text-gray-800 hover:text-yellow-700 group hover:border-yellow-700 transition-all duration-300 rounded-xl border"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-6 h-6 fill-gray-800  group-hover:fill-yellow-700 transition-all duration-300"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z"
                    clip-rule="evenodd"
                  />
                </svg>

                <span>مشاهده دوره</span>
              </button>
            ) : !token || !user?.user?.name ? (
              <Link
                to={"/auth"}
                className="w-fit px-4 h-11 flex justify-center items-center gap-1 bg-gray-200 hover:bg-transparent text-gray-800 hover:text-yellow-700 group hover:border-yellow-700 transition-all duration-300 rounded-xl border"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-6 h-6 fill-gray-800  group-hover:fill-yellow-700 transition-all duration-300"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z"
                    clip-rule="evenodd"
                  />
                </svg>

                <span>ورود و مشاهده دوره</span>
              </Link>
            ) : (
              course.buy === true && (
                <Link
                  to={"/shop"}
                  className="w-fit px-4 h-11 flex justify-center items-center gap-1 bg-gray-200 hover:bg-transparent text-gray-800 hover:text-yellow-700 group hover:border-yellow-700 transition-all duration-300 rounded-xl border"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="w-6 h-6 fill-gray-800  group-hover:fill-yellow-700 transition-all duration-300"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span>خرید و مشاهده دوره</span>
                </Link>
              )
            )}

            <div className="max-w-96 flex flex-col gap-3">
              {course?.buy === false ||
                user?.user?.developer === 1 ||
                (course?.ranks?.filter(
                  (item) => item.rank >= user?.user?.level || item.rank === 100
                ).length && (
                  <>
                    <div className="w-full flex justify-between items-center text-gray-200 text-sm">
                      <span>درصد تکمیل دوره</span>
                      <span>{toFarsiNumber(percent)}</span>
                    </div>

                    <div className="w-full h-2 rounded-full bg-black bg-opacity-30">
                      <div
                        style={{ width: percent }}
                        className="h-full bg-gray-100 rounded-full"
                      ></div>
                    </div>
                  </>
                ))}

              {percent === "100%" && !lic && !course.buy ? (
                <>
                  <p className="text-sm mt-1">
                    شما این دوره را بصورت کامل مشاهده نموده اید و میتوانید برای
                    دریافت گواهی این دوره اقدام کنید :
                  </p>

                  <button
                    onClick={licRequestHandler}
                    className="mt-1 h-10 rounded-xl flex justify-center items-center w-full text-sm bg-gradient-to-tl from-green-700 to-green-500 text-white"
                  >
                    {licLoading ? (
                      <CircleLoading />
                    ) : (
                      <span>درخواست دریافت گواهی</span>
                    )}
                  </button>
                </>
              ) : (
                percent === "100%" &&
                lic &&
                !course.buy && (
                  <p className="text-sm mt-1 text-green-500">
                    درخواست دریافت گواهی شما ثبت و درحال بررسی میباشد...
                  </p>
                )
              )}
            </div>

            <div className="flex flex-col gap-4 mt-2">
              {course.name && (
                <div className="flex items-center text-gray-300 gap-1">
                  <a href="#teachers">اساتید : </a>
                  {course.teachers.length > 0
                    ? course.teachers.map((t) => (
                        <Link
                          to={`/teacher-profile/${t?.teacher?.slug}`}
                          className="text-sm bg-black bg-opacity-30 py-1 px-2 rounded-lg"
                        >
                          {t.teacher?.name ? t.teacher.name : "ثبت نشده"}
                        </Link>
                      ))
                    : "استادی ثبت نشده !"}
                </div>
              )}

              {course.imdb && (
                <span className="block mb-3">
                  امتیاز جهانی : {toFarsiNumber(course.imdb)}
                </span>
              )}
            </div>
          </div>
        )}
      </div>

      {/* units & info */}
      <div
        id="watch-course"
        className="w-full max-w-[1300px] flex flex-col gap-8 lg:-mt-5 relative z-10 px-3 2xl:px-0"
      >
        {loading ? (
          <div className="w-full block md:flex items-center flex-col md:flex-row gap-4">
            <Skeleton className="block w-full md:w-32 h-12 rounded-xl" />
            <Skeleton className="block w-full md:w-96 h-12 rounded-xl" />
          </div>
        ) : (
          <div className="flex flex-col md:flex-row items-center gap-4">
            {/* units selection */}
            <Dropdown
              className="h-12 w-full md:w-fit filter-dropdown rounded-xl bg-[#222222] !text-gray-200 !border-none flex items-center justify-center text-center"
              value={selectedUnit}
              options={units}
              optionLabel="name"
              onChange={(e) => setSelectedUnit(e.value)}
              placeholder="انتخاب سرفصل"
              emptyMessage="سرفصلی وجود ندارد"
            />

            {/* units length */}
            {course?.name && (
              <div className="w-full md:w-fit h-12 rounded-xl bg-[#222] text-gray-200 text-xs sm:text-sm flex justify-center items-center gap-5 px-3">
                <div
                  ref={scroll}
                  className="flex items-center gap-2 border-l border-gray-800 pl-5"
                >
                  <svg viewBox="0 0 30 30" fill="none" className="min-w-5 size-5 md:min-w-7 md:size-7">
                    <g clip-path="url(#clip0_16448:5568)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M24.19 6H5C3.34 6 2 7.35 2 9V18.79C2 20.44 3.34 21.79 5 21.79H24.19C25.85 21.79 27.19 20.44 27.19 18.79V9C27.19 7.35 25.85 6 24.19 6ZM17.11 14.67L14.24 16.33C13.57 16.71 12.74 16.23 12.74 15.46V12.15C12.74 11.38 13.57 10.9 14.24 11.28L17.11 12.94C17.78 13.32 17.78 14.29 17.11 14.67Z"
                        className="fill-gray-200"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.36001 24.0699H22.74C22.99 24.0699 23.19 23.8699 23.19 23.6199C23.19 23.3699 22.99 23.1699 22.74 23.1699H6.36001C6.11001 23.1699 5.91001 23.3699 5.91001 23.6199C5.90001 23.8699 6.11001 24.0699 6.36001 24.0699Z"
                        className="fill-gray-200"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_16448:5568">
                        <rect
                          width="25.19"
                          height="18.07"
                          fill="white"
                          transform="translate(2 6)"
                        ></rect>
                      </clipPath>
                    </defs>
                  </svg>

                  <span>
                    تعداد کل فصل ها : {toFarsiNumber(course.units.length)}
                  </span>
                </div>
                {/* course status */}
                <span>
                  وضعیت دوره :{" "}
                  {course.course_status === 0
                    ? "درحال برگذاری"
                    : course.course_status === 1 && "اتمام دوره"}
                </span>
              </div>
            )}
          </div>
        )}

        {/* episodes */}
        {loading ? (
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <AcademyEpisodeLoading />
            <AcademyEpisodeLoading />
            <AcademyEpisodeLoading />
            <AcademyEpisodeLoading />
          </div>
        ) : selectedUnit?.episodes?.length > 0 ? (
          <div
            className={`w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4`}
          >
            {selectedUnit.episodes.map((ep) => (
              <EpisodeItem ep={ep} user={user} course={course} />
            ))}
          </div>
        ) : (
          <span className="text-gray-200">درسی در این سرفصل وجود ندارد !</span>
        )}

        {/* description */}
        <div
          className={`w-full ${
            openDesc ? "h-auto" : "h-64"
          } flex flex-col gap-4 md:p-5 p-3 pt-6 relative bg-[#222] overflow-hidden rounded-xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]`}
        >
          <div className="flex items-center gap-2">
            <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
            <h3 className="md:text-2xl text-xl font-black text-gray-200">
              توضیحات
            </h3>
          </div>

          {loading ? (
            <Skeleton count={10} className="w-full block h-6 rounded-xl" />
          ) : (
            <>
              <div
                dangerouslySetInnerHTML={{ __html: course.description }}
                className="course-content leading-8 text-[17px] text-gray-400"
              ></div>

              {/* read more */}
              <div
                className={`bg-gradient-to-t from-[#222] w-full ${
                  openDesc ? "relative" : "absolute h-52"
                } bottom-0 right-0 flex items-end pb-5 justify-center`}
              >
                <button
                  onClick={() => setOpenDesc(!openDesc)}
                  className="w-36 h-12 rounded-xl bg-gradient-to-tl from-yellow-900 to-yellow-500 text-white"
                >
                  {openDesc ? "نمایش کمتر" : "نمایش بیشتر"}
                </button>
              </div>
            </>
          )}
        </div>

        {/* pakcages */}
        {!loading && course.products.length > 0 && (
          <div className="w-full h-auto flex flex-col gap-6 md:p-5 p-3 pt-6 relative bg-[#222] overflow-hidden rounded-xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                <h3 className="md:text-2xl text-xl font-black text-gray-200">
                  پکیج هایی که این دوره در آن ها موجود است
                </h3>
              </div>
            </div>

            {loading ? (
              <Skeleton
                count={4}
                className="w-full block h-[70px] rounded-xl"
              />
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {course.products.length > 0 ? (
                  course.products.map(
                    (p) =>
                      p.product && (
                        <Link
                          to={`/shop/${p.product.slug}`}
                          className="border border-gray-800 hover:border-gray-700 transition-all duration-300 flex gap-2 items-center p-2 rounded-xl h-20"
                        >
                          <img
                            src={`https://api.myunibest.com/${p.product.image[0].image}`}
                            className="h-full rounded-lg"
                            alt=""
                          />
                          <div className="flex flex-col gap-3">
                            <h3 className="text-gray-200 font-bold">
                              {p.product.title}
                            </h3>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: p.product.description,
                              }}
                              className="text-sm text-gray-400 line-clamp-1"
                            ></div>
                          </div>
                        </Link>
                      )
                  )
                ) : (
                  <span className="text-gray-200">
                    این دوره درحال حاضر در در پکیجی وجود ندارد
                  </span>
                )}
              </div>
            )}
          </div>
        )}

        {/* teachers */}
        <div
          className={`w-full flex flex-col gap-4 md:p-5 p-3 pt-6 relative bg-[#222] overflow-hidden rounded-xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]`}
        >
          <div id="teachers" className="flex items-center gap-2">
            <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
            <h3 className="md:text-2xl text-xl font-black text-gray-200">
              اساتید
            </h3>
          </div>

          {loading ? (
            <div className="flex justify-center items-center">
              <Loading />
            </div>
          ) : course.teachers.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-y-4">
              {course.teachers.map((t) => (
                <Link
                  to={`/teacher-profile/${t.teacher?.slug}`}
                  className="flex flex-col items-center gap-3"
                >
                  <img
                    src={
                      t.teacher?.image
                        ? `https://api.myunibest.com/${t.teacher?.image}`
                        : avatar
                    }
                    className="rounded-full w-40 h-40 object-cover object-top"
                    alt=""
                  />

                  <span className="text-gray-200 text-xl font-black">
                    {t.teacher?.name}
                  </span>
                  <span className="text-gray-400 text-sm -mt-2">{t.rank}</span>
                </Link>
              ))}
            </div>
          ) : (
            <span className="text-gray-200">
              استادی برای این دوره انتخاب نشده !
            </span>
          )}
        </div>

        {/* realated */}
        {!loading && more.length > 0 && (
          <div
            className={`w-full flex flex-col gap-4 md:p-5 p-3 pt-6 relative bg-[#222] overflow-hidden rounded-xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]`}
          >
            <div id="teachers" className="flex items-center gap-2">
              <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
              <h3 className="md:text-2xl text-xl font-black text-gray-200">
                دوره های مرتبط
              </h3>
            </div>

            <Swiper
              className="mySwiper free-course-slider header-slider pb-3"
              // effect={"fade"}
              pagination={{
                dynamicBullets: true,
              }}
              slidesPerView={productPerView2}
              navigation={true}
              spaceBetween={20}
              // autoplay={{
              //   delay: 2500,
              //   disableOnInteraction: false,
              // }}
              // loop={true}
              modules={[Autoplay, Navigation]}
            >
              {more.map((ac, i) => (
                <SwiperSlide>
                  <NewAcademyCard key={i} data={ac} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}

        {/* qa section */}
        <div className="w-full h-auto flex flex-col gap-10 md:p-5 p-3 pt-6 relative bg-[#222] overflow-hidden rounded-xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
          <div className="flex flex-col gap-6">
            {/* comment title */}
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                <h3 className="md:text-2xl text-xl font-black text-gray-200">
                  پرسش شما
                </h3>
              </div>
            </div>

            {user?.user?.id ? (
              <div className="flex flex-col gap-5">
                <SendComment type={"QA"} data={course.id} />
              </div>
            ) : (
              <span className="text-gray-200">
                برای ثبت پرسش وارد حساب کاربری شوید !
              </span>
            )}
          </div>

          <div className="flex flex-col gap-6">
            {/* comment title */}
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                <h3 className="md:text-2xl text-xl font-black text-gray-200">
                  پرسش پاسخ ها
                </h3>
              </div>

              <span className="text-lg text-gray-400">
                {!qaLoading && toFarsiNumber(qa.length)} پرسش
              </span>
            </div>

            {/* comments */}
            {qaLoading ? (
              <Loading />
            ) : (
              <div className="flex flex-col gap-4">
                {qa.length > 0 ? (
                  qa.map((comment) => (
                    <AcademyComment
                      type={"QA"}
                      lesson_id={course.id}
                      data={comment}
                    />
                  ))
                ) : (
                  <span className="text-gray-200">
                    پرسشی برای این دوره وجود ندارد !
                  </span>
                )}
              </div>
            )}
          </div>
        </div>

        {/* comment section */}
        <div className="w-full h-auto flex flex-col gap-10 md:p-5 p-3 pt-6 relative bg-[#222] overflow-hidden rounded-xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
          <div className="flex flex-col gap-6">
            {/* comment title */}
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                <h3 className="md:text-2xl text-xl font-black text-gray-200">
                  دیدگاه شما
                </h3>
              </div>
            </div>

            {loading ? (
              <Loading />
            ) : user?.user?.id ? (
              <div className="flex flex-col gap-5">
                <div className="w-full md:max-h-14 flex flex-col-reverse md:flex-row gap-4 justify-between items-center p-4 bg-gray-800 rounded-xl">
                  {course.buy ? (
                    <span className="text-gray-200">
                      برای ثبت امتیاز ابتدا دوره را خریداری کنید
                    </span>
                  ) : isRateSubmitted ? (
                    <span className="text-green-600">
                      شما قبلا امتیاز داده اید
                    </span>
                  ) : sendRate ? (
                    <div className="flex flex-col md:flex-row text-gray-200 items-center gap-4">
                      <span>مطمنید میخواهید امتیاز شما ثبت شود ؟</span>

                      <div className="flex items-center gap-4">
                        <button
                          onClick={rateSendHandler}
                          className="bg-gradient-to-tl from-green-600 to-green-300 text-sm p-2 text-white rounded-xl"
                        >
                          {rateLoading ? <CircleLoading /> : "بله ثبت امتیاز"}
                        </button>
                        <button
                          onClick={() => {
                            setSendRate(false);
                            setRate(null);
                          }}
                          className="text-red-600"
                        >
                          خیر
                        </button>
                      </div>
                    </div>
                  ) : rateSended ? (
                    <span className="text-green-500">امتیاز شما ثبت شد</span>
                  ) : (
                    <span className="text-gray-200">امتیاز شما</span>
                  )}
                  <Rating
                    value={rate}
                    readOnly={
                      rateSended || isRateSubmitted || course.buy ? true : false
                    }
                    cancel={false}
                    onChange={rateOnChangeHandler}
                  />
                </div>

                <SendComment type={"comment"} data={course.id} />
              </div>
            ) : (
              <span className="text-gray-200">
                برای ثبت امتیاز و دیدگاه وارد حساب کاربری شوید !
              </span>
            )}
          </div>

          <div className="flex flex-col gap-6">
            {/* comment title */}
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                <h3 className="md:text-2xl text-xl font-black text-gray-200">
                  دیدگاه کاربران
                </h3>
              </div>

              <span className="text-lg text-gray-400">
                {!commentLoading && toFarsiNumber(comments.length)} دیدگاه
              </span>
            </div>

            {/* comments */}
            {commentLoading ? (
              <Loading />
            ) : (
              <div className="flex flex-col gap-4">
                {comments.length > 0 ? (
                  comments.map((comment) => (
                    <AcademyComment
                      type={"comment"}
                      lesson_id={course.id}
                      data={comment}
                    />
                  ))
                ) : (
                  <span className="text-gray-200">
                    دیدگاهی برای این دوره وجود ندارد !
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
